import apiClient from './apiClient';

export const getTerminKategorien = async () => {
  const response = await apiClient.get('/termin-kategorien');
  return response.data;
};

export const createTerminKategorie = async (payload) => {
  const response = await apiClient.post('/termin-kategorien', payload);
  return response.data;
};

export const updateTerminKategorie = async (id, payload) => {
  const response = await apiClient.put(`/termin-kategorien/${id}`, payload);
  return response.data;
};

export const deleteTerminKategorie = async (id) => {
  const response = await apiClient.delete(`/termin-kategorien/${id}`);
  return response.data;
};

export const reorderTerminKategorien = async (ids) => {
  const response = await apiClient.post('/termin-kategorien/reorder', { ids });
  return response.data;
};
